<template>
  <div id="app">
    <router-view/>
    <vue-progress-bar></vue-progress-bar>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { responsive } from '@/utils/utils'

export default {
  name: 'App',

  created () {
    this.withProgress(window, window.fetch)
  },

  updated () {
    this.withProgress(window, window.fetch)
  },

  mounted() {
    this.setResponsive(responsive())
    this.detectConnection()

    window.addEventListener('resize', () => {
      window.requestAnimationFrame(() => {
        this.setResponsive(responsive())
      })
    })
  },

  methods: {
    withProgress (w, fetch) {
      if (typeof fetch !== 'function') {
        return
      }
      const progress = this.$Progress
      progress.start()

      w.fetch = function () {
        const r = fetch.apply(this, arguments)

        r.then(() => { progress.finish() })
          .catch(() => { progress.fail() })

        return r
      }
  },
  ...mapActions({
      detectConnection: 'userSettings/detectConnection',
      setResponsive: 'userSettings/setResponsive'
    })
  }
}
</script>
<style lang="scss">
@import url('https://fonts.googleapis.com/css?family=Work+Sans:400,700');
@import '@/assets/scss/_vars.scss';
@import '@/assets/scss/_global.scss';

/* New Stunt is overwriting app font-family */
#app {
  font-family: BlinkMacSystemFont, -apple-system, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif!important;
}

/* Mini CSS reset */
ul {
  padding: 0;
}

li {
  list-style-type: none;
}

a {
  text-decoration: none;
}

img {
  height: auto;
  max-width: 100%;
}

hr {
  border: none;
  display: block;
  background-color: $white;
  margin: 1.5rem 0;
}
</style>
